export const LOCALE_COOKIE_NAME = 'slam-locale';

export const LANGUAGES = ['en', 'de', 'fr', 'it'];

export const ALLOWED_LOCALES = [
	'en-GB',
	'de-CH',
	'de-DE',
	'de-AT',
	'de-LU',
	'fr-FR',
	'fr-CH',
	'fr-LU',
	'it-IT',
	'it-CH'
];

// Acceptable href langs. We put the language-only codes last, so they have the least priority
export const VALID_HREF_LANGUAGES = [...ALLOWED_LOCALES, ...LANGUAGES];
